export const SeasonStageType = {
	REGULAR_SEASON: 'regular_season',
	POST_SEASON:    'post_season',
};
